import { render, staticRenderFns } from "./SimpleChip.vue?vue&type=template&id=36a0725d&scoped=true&"
import script from "./SimpleChip.vue?vue&type=script&lang=js&"
export * from "./SimpleChip.vue?vue&type=script&lang=js&"
import style0 from "./SimpleChip.vue?vue&type=style&index=0&id=36a0725d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a0725d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VIcon})
